import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesOverview from './components/ServicesOverview';
import TrustSection from './components/TrustSection';
import AboutPreview from './components/AboutPreview';
import FaqSection from './components/FaqSection';
import ContactBanner from './components/ContactBanner';
import usePageMeta from '@/hooks/usePageMeta';

const HomePage = () => {
  usePageMeta({
    title: 'gowiTEC Reichshof – Sondermaschinenbau, SPS-Technik & Automatisierung',
    description: 'gowiTEC Reichshof: Sondermaschinenbau, SPS-Steuerung & Automatisierungstechnik seit 1992. Individuelle Lösungen für Industrie und Maschinenbau in Reichshof-Wehnrath, NRW.',
    keywords: 'Sondermaschinenbau Reichshof, SPS-Technik, Automatisierung, Steuerungstechnik, Maschinenbau NRW',
    canonical: 'https://gowitec.de/',
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesOverview />
        <TrustSection />
        <AboutPreview />
        <FaqSection />
        <ContactBanner />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
